import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import ProductSidebar from "./sideBarProduct";

import { getCategories } from "../../api/categoryApi";
import { getSubCategoryByCategory } from "../../api/subCategoryApi";
import { getProducts } from "../../api/productApi";
import ProductCard from "./productCard";
import background from "../../assets/img/backgorund.png";

export default function ProductPage() {
  const { slug } = useParams();

  const navigate = useNavigate();

  const [categories, setCategories] = useState<any[]>([]);
  const [subCategories, setSubCategories] = useState<any[]>([]);
  const [products, setProducts] = useState<any[]>([]);

  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState<number>(0);

  const [loading, setLoading] = useState(false);

  const loadCategories = async () => {
    const result = await getCategories({
      page: 1,
      limit: 10,
    });

    setCategories(result.data.categoryList);
  };

  const loadSubCategories = async (categoryId: number) => {
    const result = await getSubCategoryByCategory(categoryId);

    setSubCategories(result.data.data.subCategoryList);
  };

  useEffect(() => {
    const loadData = async () => {
      if (!slug || categories.length === 0) return;

      const category = categories.find((item: any) => item.slug === slug);

      if (category) {
        await Promise.all([
          loadSubCategories(category.id),
          loadProducts(category.id),
        ]);
      }
    };

    loadData();
  }, [slug, categories]);

  const currentCategory = categories.find((item: any) => item.slug === slug);

  useEffect(() => {
    loadCategories();
  }, []);
  const loadProducts = async (categoryId: number, subCategoryId?: number) => {
    const result = await getProducts(categoryId, subCategoryId);

    setProducts(result.data.productList);
  };

  const handleCardClick = (id: number) => {
    navigate(`/product/${id}`);
  };

  return (
    <section className="bg-white min-h-screen">
      {/* Hero */}
      <div
        className="relative h-[300px] bg-cover bg-center"
        style={{
          backgroundImage: `url(${background})`,
        }}>
        {/* Content */}
        <div className="relative flex h-full items-center">
          <div className="mx-auto w-full max-w-7xl px-8 text-white">
            <h1 className="text-5xl font-bold">
              {currentCategory?.categoryName}
            </h1>

            <p className="mt-4 max-w-2xl text-white/90">
              {currentCategory?.slug}
            </p>
          </div>
        </div>
      </div>

      {/* Content */}
      <div
        className="
          max-w-7xl
          mx-auto
          px-8
          py-12
          grid
          grid-cols-1
          lg:grid-cols-[250px_1fr]
          gap-8
          items-start
        ">
        <ProductSidebar
          categories={subCategories}
          selected={selectedSubCategoryId}
          onSelect={async (subCategoryId) => {
            setSelectedSubCategoryId(subCategoryId);

            const category = categories.find((item: any) => item.slug === slug);

            if (!category) return;

            if (subCategoryId === 0) {
              await loadProducts(category.id);
            } else {
              await loadProducts(category.id, subCategoryId);
            }
          }}
        />

        {/*
          Grid produk - "self-responsive" pakai auto-fill/minmax, bukan
          breakpoint manual satu-satu. Mobile tetap fix 2 kolom (produk
          kamu proporsinya ramping, 1 kolom kegedean & boros scroll).
          Mulai dari `sm` ke atas, jumlah kolom otomatis nyesuain lebar
          layar berdasarkan minimum 180px per card -- smooth di semua
          ukuran, termasuk pas browser di-resize manual.
        */}
        <div
          className="
            grid
            grid-cols-2
            gap-4

            sm:grid-cols-[repeat(auto-fill,minmax(180px,1fr))]
            sm:gap-6

            lg:gap-8
          ">
          {loading ? (
            <div className="col-span-full flex min-h-[300px] items-center justify-center">
              <p className="text-gray-500">Loading products...</p>
            </div>
          ) : products.length === 0 ? (
            <div className="col-span-full flex min-h-[300px] items-center justify-center">
              <div className="text-center">
                <p className="text-lg font-semibold text-[#324A5A]">
                  Product is empty
                </p>

                <p className="mt-2 text-sm text-gray-500">
                  Belum ada produk pada kategori ini.
                </p>
              </div>
            </div>
          ) : (
            products.map((product: any) => (
              <ProductCard
                key={product.id}
                id={product.id}
                title={product.productName}
                image={product.image}
                subtitle={product.category}
                onClick={handleCardClick}
              />
            ))
          )}
        </div>
      </div>
    </section>
  );
}
